import { Pipe, PipeTransform } from '@angular/core';
import {
  CountryCode,
  MsisdnStatus,
  PortingRequestStatus,
  PortingType,
  SimonSimStatus,
} from 'src/app/core';
import { LineStatus } from 'src/app/core/proto/whitepages/lines';

@Pipe({ name: 'ViewComputer' })
export class ViewComputerPipe implements PipeTransform {
  transform(value: any, selector: string, data?: any): string {
    switch (selector) {
      /************************************/
      /*      SIM AND LINE MANAGEMENT     */
      /************************************/

      case 'VIEW_SIM_INFO_STATUS':
        if (value === SimonSimStatus.HOT) {
          return 'success';
        } else if (value === SimonSimStatus.WARM) {
          return 'warning';
        } else {
          return 'default';
        }

      case 'VIEW_LINE_STATUS':
        if (value === LineStatus.PENDING) {
          return 'default';
        } else if (value === LineStatus.ACTIVATED) {
          return 'success';
        } else if (value === LineStatus.DEACTIVATED) {
          return 'warning';
        } else if (value === LineStatus.TERMINATED) {
          return 'error';
        } else {
          return 'default';
        }

      case 'VIEW_SIM_SET_METADATA':
        if (
          data.status === SimonSimStatus.COLD ||
          data.status === SimonSimStatus.WARM ||
          data.status === SimonSimStatus.HOT
        ) {
          return value;
        } else {
          return;
        }

      case 'VIEW_VIEW_LINE_INFO': {
        if (data.lineId) {
          return value;
        } else {
          return;
        }
      }

      case 'VIEW_VIEW_SIM_INFO': {
        if (data.iccid) {
          return value;
        } else {
          return;
        }
      }

      case 'VIEW_BILL_TO_ACCOUNT_NAME':
        if (data.length > 0) {
          const brandName = data.filter(theBrand => theBrand.billToAccountId === value);
          return brandName.name || 'N/A';
        } else {
          return 'N/A';
        }

      case 'VIEW_LINE_SET_METADATA':
        if (
          data.status === LineStatus.PENDING ||
          data.status === LineStatus.ACTIVATED ||
          data.status === LineStatus.DEACTIVATED
        ) {
          return value;
        } else {
          return;
        }

      case 'VIEW_LINE_SIM_SWAP':
        if (data.phoneNumbers?.length > 0) {
          if (
            (data.status === LineStatus.ACTIVATED ||
              data.status === LineStatus.DEACTIVATED) &&
            data.phoneNumbers[0]?.msisdnStatus === MsisdnStatus.ACTIVE
          ) {
            return value;
          } else {
            return;
          }
        } else {
          return;
        }

      case 'VIEW_LINE_SEND_MESSAGE':
        if (
          data.status !== LineStatus.DEACTIVATED &&
          data.status !== LineStatus.TERMINATED
        ) {
          return value;
        } else {
          return;
        }

      case 'VIEW_DEACTIVATE_LINE':
        if (data.status === LineStatus.ACTIVATED) {
          return value;
        } else {
          return;
        }

      case 'VIEW_REACTIVATE_LINE':
        if (data.phoneNumbers?.length > 0) {
          if (
            data.status === LineStatus.DEACTIVATED &&
            data.phoneNumbers[0]?.msisdnStatus === MsisdnStatus.ACTIVE
          ) {
            return value;
          } else {
            return;
          }
        } else {
          return;
        }

      case 'VIEW_TERMINATE_LINE':
        if (data.status === LineStatus.PENDING) {
          return value;
        } else {
          return;
        }

      case 'VIEW_SWAP_SIM':
        if (data.lineId && data.status === SimonSimStatus.HOT) {
          return value;
        } else {
          return;
        }

      /************************************/
      /*      PHONE NUMBER MANAGEMENT     */
      /************************************/

      case 'VIEW_PORTING_STATUS':
        if (value === PortingRequestStatus.PORTING_REQUESTED) {
          return 'warning';
        } else if (
          value === PortingRequestStatus.PORTING_CANCELLATION_PENDING
        ) {
          return 'warning';
        } else if (value === PortingRequestStatus.PORTING_CANCELLED) {
          return 'error';
        } else if (value === PortingRequestStatus.PORTING_PENDING) {
          return 'warning';
        } else if (value === PortingRequestStatus.PORTING_COMPLETED) {
          return 'success';
        } else if (value === PortingRequestStatus.PORTING_FAILED) {
          return 'error';
        } else {
          return 'default';
        }

      case 'VIEW_NUMBER_PORTING_CANCEL': {
        if (
          data.type === PortingType.PORT_IN &&
          data.country !== CountryCode.US &&
          (data.status === PortingRequestStatus.PORTING_REQUESTED ||
            data.status === PortingRequestStatus.PORTING_READY_FOR_SCHEDULING ||
            data.status === PortingRequestStatus.PORTING_SCHEDULED)
        ) {
          return value;
        } else {
          return;
        }
      }

      case 'VIEW_EXPAND_PORTING': {
        if (data.status === PortingRequestStatus.PORTING_FAILED) {
          return value;
        } else {
          return;
        }
      }

      case 'VIEW_NUMBER_PORTING_SCHEDULE': {
        if (
          data.type === PortingType.PORT_IN &&
          data.country !== CountryCode.US &&
          data.status === PortingRequestStatus.PORTING_READY_FOR_SCHEDULING
        ) {
          return value;
        } else {
          return;
        }
      }

      case 'VIEW_NUMBER_PORTING_RETRY': {
        if (
          data.status === PortingRequestStatus.PORTING_FAILED &&
          data.country !== CountryCode.US &&
          data.failureSource === 'Vendor'
        ) {
          return value;
        } else {
          return;
        }
      }

      case 'VIEW_COUNTRY_CODE': {
        // Use ngx-intl-tel-input CountryISO to lowercase to display the flag class in table
        if (value) {
          return value.toLocaleLowerCase();
        } else {
          return;
        }
      }

      default:
        break;
    }
    return value;
  }
}
